/**
 * Тип для API endpoint ключей
 */
export type ApiEndpointKey = 'LANDING' | 'IMAGES' | 'STUDENT_UI' | 'LOCALIZATION'

/**
 * Интерфейс для конфигурации endpoints
 */
export interface ApiEndpointsConfig {
  NUXT_APP_LANDING_API: string
  NUXT_APP_IMAGES_API: string
  NUXT_APP_STUDENT_UI: string
  NUXT_APP_LOCALIZATION_API: string
}

/**
 * Получить endpoints из runtimeConfig (для использования в Vue контексте)
 */
export function getApiEndpoints(): Record<ApiEndpointKey, string> {
  const config = useRuntimeConfig()
  return {
    LANDING: config.public.NUXT_APP_LANDING_API,
    IMAGES: config.public.NUXT_APP_IMAGES_API,
    STUDENT_UI: config.public.NUXT_APP_STUDENT_UI,
    LOCALIZATION: config.public.NUXT_APP_LOCALIZATION_API,
  }
}

/**
 * Получить базовый URL для endpoint (для использования в Vue контексте)
 */
export function getApiBaseUrl(apiEndpointKey: ApiEndpointKey): string {
  const endpoints = getApiEndpoints()
  return endpoints[apiEndpointKey]
}

/**
 * Получить базовый URL для endpoint из конфига (для использования вне Vue контекста)
 */
export function getApiBaseUrlFromConfig(apiEndpointKey: ApiEndpointKey, config: ApiEndpointsConfig): string {
  const endpoints: Record<ApiEndpointKey, string> = {
    LANDING: config.NUXT_APP_LANDING_API,
    IMAGES: config.NUXT_APP_IMAGES_API,
    STUDENT_UI: config.NUXT_APP_STUDENT_UI,
    LOCALIZATION: config.NUXT_APP_LOCALIZATION_API,
  }
  return endpoints[apiEndpointKey]
}

/**
 * Конфигурация по умолчанию для запросов
 */
export const DEFAULT_REQUEST_CONFIG = {
  timeout: 30000, // 30 секунд
  retries: 0, // Количество повторных попыток
  retryDelay: 1000, // Задержка между попытками (мс)
} as const

